import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d619491")

_pushScopeId("data-v-0d619491")
const _hoisted_1 = { class: "bg-secondary flex items-center justify-between px-2 py-1" }
const _hoisted_2 = { class: "counters flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-white"
}
const _hoisted_4 = {
  key: 1,
  class: "text-white"
}
const _hoisted_5 = {
  key: 2,
  class: "text-white"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCounter(10))),
        class: {'bg-primary text-white': _ctx.counter === 10, 'text-gray-400': _ctx.counter !== 10}
      }, "10", 2),
      _createVNode("span", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCounter(25))),
        class: {'bg-primary text-white': _ctx.counter === 25, 'text-gray-400': _ctx.counter !== 25}
      }, "25", 2),
      _createVNode("span", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCounter(100))),
        class: {'bg-primary text-white': _ctx.counter === 100, 'text-gray-400': _ctx.counter !== 100}
      }, "100", 2)
    ]),
    (_ctx.perPage > 0)
      ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.initalCount) + " a " + _toDisplayString(_ctx.endingCount) + " de " + _toDisplayString(_ctx.total), 1))
      : (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.total) + " items ", 1)),
    (_ctx.perPage > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_fa_icon, {
            class: "cursor-pointer mx-1",
            icon: ['fas', 'arrow-circle-left'],
            size: "lg",
            onClick: _ctx.previousPage
          }, null, 8, ["onClick"]),
          _createVNode(_component_fa_icon, {
            class: "cursor-pointer mx-1",
            icon: ['fas', 'arrow-circle-right'],
            size: "lg",
            onClick: _ctx.nextPage
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})